import store from '@/store'
import network from '@/utils/network'
import { agencyPath, agentPath, computeFilters, createRequestWithComputedFilters, customerPath } from '@/utils/api'
import { ACCOUNT_RIGHT_LIST_MISSIONS } from '@/consts/rights'
import { SERVICE_INDEXED_ACTIVITY_TYPE_LIST } from '@/consts/services'

/**
 * Récupère la liste des services
 * @returns {Promise}
 */
export const fetchServices = createRequestWithComputedFilters(
  async (params) => {
    const isAgent = store.getters['user/isAgent']
    const entryPoint = `${isAgent && !store.getters['user/isGranted'](ACCOUNT_RIGHT_LIST_MISSIONS)
      ? agencyPath() + agentPath()
      : agencyPath() + customerPath()}`
    const res = await network.post(`${entryPoint}/fetch/circuits`, params)
    const { data: { sites, customers, specialties, agents, data, ...infos } } = res
    const _site = _.mapValues(sites, (s) => {
      return {
        ...s,
        customer: customers[s.customer] || undefined
      }
    })
    const mapServices = (s) => ({
      ...s,
      agent: agents[s.agent] || undefined,
      specialty: specialties[s.specialty] || undefined,
      activityType: SERVICE_INDEXED_ACTIVITY_TYPE_LIST[s.activityType] || undefined,
      site: _site[s.site] || undefined,
      services: s.services ? s.services.map(mapServices) : undefined
    })
    return {
      ...infos,
      data: data.map(mapServices)
    }
  },
  {
    limit: 10,
    filters: {
      isAgent: -1,
      isInvoice: -1,
      isPlanned: -1,
      status: []
    }
  }
)

/**
 * Récupère la liste des mains courantes d'un site
 * @returns {Promise}
 */
export const fetchSiteEvents = createRequestWithComputedFilters(
  async ({ reference, ...params }) => {
    const slugAgency = store.getters['user/agencySlug']
    const r = await network.post(`agency/${slugAgency}/circuit/${reference}/fetch/events`, params)
    return r.data
  }
)

/**
 * Applique des actions sur un lot de services
 * @param {string} action
 * @param {{}}filters
 * @returns {Promise<T>}
 */
export const multiActionsService = async (action, filters = {}) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.put(
    `agency/${slugAgency}/services/${action}`,
    {
      filters: computeFilters({
        ...{
          isAgent: -1,
          isInvoice: -1,
          isPlanned: -1,
          status: []
        },
        ...filters
      })
    })
  return r.data
}
